import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { LazySelectComponent } from './lazy-select.component';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [LazySelectComponent],
  imports: [
    CommonModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatInputModule,
    MatIconModule,
    ReactiveFormsModule
  ],
  exports: [LazySelectComponent]
})
export class LazySelectModule { }